export const tornadoTreesAddress = '0x527653eA119F3E6a1F5BD18fbF4714081D7B31ce';
export const eth100 = '0xA160cdAB225685dA1d56aa342Ad8841c3b53f291';
export const tornadoDepositENS = [
    'eth-01.tornadocash.eth',
    'eth-1.tornadocash.eth',
    'eth-10.tornadocash.eth',
    'eth-100.tornadocash.eth',
    'dai-100.tornadocash.eth',
    'dai-1000.tornadocash.eth',
    'dai-10000.tornadocash.eth',
    'dai-100000.tornadocash.eth',
    'cdai-5000.tornadocash.eth',
    'cdai-50000.tornadocash.eth',
    'cdai-500000.tornadocash.eth',
    'cdai-5000000.tornadocash.eth',
    'usdc-100.tornadocash.eth',
    'usdc-1000.tornadocash.eth',
    'usdt-100.tornadocash.eth',
    'usdt-1000.tornadocash.eth',
    'wbtc-01.tornadocash.eth',
    'wbtc-1.tornadocash.eth',
    'wbtc-10.tornadocash.eth',
];
export const tornadoDepositAddresses = [
    '0x12d66f87a04a9e220743712ce6d9bb1b5616b8fc',
    '0x47ce0c6ed5b0ce3d3a51fdb1c52dc66a7c3c2936',
    '0x910cbd523d972eb0a6f4cae4618ad62622b39dbf',
    '0xa160cdab225685da1d56aa342ad8841c3b53f291',
    '0xd4b88df4d29f5cedd6857912842cff3b20c8cfa3',
    '0xfd8610d20aa15b7b2e3be39b396a1bc3516c7144',
    '0x07687e702b410fa43f4cb4af7fa097918ffd2730',
    '0x23773e65ed146a459791799d01336db287f25334',
    '0x22aaa7720ddd5388a3c0a3333430953c68f1849b',
    '0x03893a7c7463ae47d46bc7f091665f1893656003',
    '0x2717c5e28cf931547b621a5dddb772ab6a35b701',
    '0xd21be7248e0197ee08e0c20d4a96debdac3d20af',
    '0xd96f2b1c14db8458374d9aca76e26c3d18364307',
    '0x4736dcf1b7a3d580672cce6e7c65cd5cc9cfba9d',
    '0x169ad27a470d064dede56a2d3ff727986b15d52b',
    '0x0836222f2b2b24a3f36f98668ed8f0b38d1a872f',
    '0x178169b423a011fff22b9e3f3abea13414ddd0f1',
    '0x610b717796ad172b316836ac95a2ffad065ceab4',
    '0xbb93e510bbcd0b7beb5a853875f9ec60275cf498',
    '0x722122dF12D4e14e13Ac3b6895a86e84145b6967'
];
export const tornadoAddressAssetMap = {
    '0x722122dF12D4e14e13Ac3b6895a86e84145b6967': 'ETH',
    '0x12d66f87a04a9e220743712ce6d9bb1b5616b8fc': 'ETH',
    '0x47ce0c6ed5b0ce3d3a51fdb1c52dc66a7c3c2936': 'ETH',
    '0x910cbd523d972eb0a6f4cae4618ad62622b39dbf': 'ETH',
    '0xa160cdab225685da1d56aa342ad8841c3b53f291': 'ETH',
    '0xd4b88df4d29f5cedd6857912842cff3b20c8cfa3': 'DAI',
    '0xfd8610d20aa15b7b2e3be39b396a1bc3516c7144': 'DAI',
    '0x07687e702b410fa43f4cb4af7fa097918ffd2730': 'DAI',
    '0x23773e65ed146a459791799d01336db287f25334': 'DAI',
    '0x22aaa7720ddd5388a3c0a3333430953c68f1849b': 'cDAI',
    '0x03893a7c7463ae47d46bc7f091665f1893656003': 'cDAI',
    '0x2717c5e28cf931547b621a5dddb772ab6a35b701': 'cDAI',
    '0xd21be7248e0197ee08e0c20d4a96debdac3d20af': 'cDAI',
    '0xd96f2b1c14db8458374d9aca76e26c3d18364307': 'USDC',
    '0x4736dcf1b7a3d580672cce6e7c65cd5cc9cfba9d': 'USDC',
    '0x169ad27a470d064dede56a2d3ff727986b15d52b': 'USDT',
    '0x0836222f2b2b24a3f36f98668ed8f0b38d1a872f': 'USDT',
    '0x178169b423a011fff22b9e3f3abea13414ddd0f1': 'wBTC',
    '0x610b717796ad172b316836ac95a2ffad065ceab4': 'wBTC',
    '0xbb93e510bbcd0b7beb5a853875f9ec60275cf498': 'wBTC',
};
export const TornadoTreesAbi = [
    {
        inputs: [
            { internalType: 'address', name: '_governance', type: 'address' },
            {
                internalType: 'contract ITornadoTreesV1',
                name: '_tornadoTreesV1',
                type: 'address',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'depositsFrom',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'depositsStep',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'withdrawalsFrom',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'withdrawalsStep',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct TornadoTrees.SearchParams',
                name: '_searchParams',
                type: 'tuple',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'instance',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'block',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'DepositData',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'newProxy',
                type: 'address',
            },
        ],
        name: 'ProxyUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'newVerifier',
                type: 'address',
            },
        ],
        name: 'VerifierUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'instance',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'block',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'WithdrawalData',
        type: 'event',
    },
    {
        inputs: [],
        name: 'BYTES_SIZE',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'CHUNK_SIZE',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'CHUNK_TREE_HEIGHT',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'ITEM_SIZE',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'SNARK_FIELD',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'blockNumber',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'depositRoot',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'deposits',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'depositsLength',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'depositsV1Length',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'contract ITornadoTreesV1',
                name: '_tornadoTreesV1',
                type: 'address',
            },
            { internalType: 'string', name: '_type', type: 'string' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
        ],
        name: 'elementExists',
        outputs: [{ internalType: 'bool', name: 'success', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'governance',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_tornadoProxy', type: 'address' },
            {
                internalType: 'contract IBatchTreeUpdateVerifier',
                name: '_treeUpdateVerifier',
                type: 'address',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastProcessedDepositLeaf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastProcessedWithdrawalLeaf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'previousDepositRoot',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'previousWithdrawalRoot',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_instance', type: 'address' },
            { internalType: 'bytes32', name: '_commitment', type: 'bytes32' },
        ],
        name: 'registerDeposit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_instance', type: 'address' },
            { internalType: 'bytes32', name: '_nullifierHash', type: 'bytes32' },
        ],
        name: 'registerWithdrawal',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_tornadoProxy', type: 'address' }],
        name: 'setTornadoProxyContract',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'contract IBatchTreeUpdateVerifier',
                name: '_treeUpdateVerifier',
                type: 'address',
            },
        ],
        name: 'setVerifierContract',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tornadoProxy',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tornadoTreesV1',
        outputs: [
            {
                internalType: 'contract ITornadoTreesV1',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'treeUpdateVerifier',
        outputs: [
            {
                internalType: 'contract IBatchTreeUpdateVerifier',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes', name: '_proof', type: 'bytes' },
            { internalType: 'bytes32', name: '_argsHash', type: 'bytes32' },
            { internalType: 'bytes32', name: '_currentRoot', type: 'bytes32' },
            { internalType: 'bytes32', name: '_newRoot', type: 'bytes32' },
            { internalType: 'uint32', name: '_pathIndices', type: 'uint32' },
            {
                components: [
                    { internalType: 'bytes32', name: 'hash', type: 'bytes32' },
                    { internalType: 'address', name: 'instance', type: 'address' },
                    { internalType: 'uint32', name: 'block', type: 'uint32' },
                ],
                internalType: 'struct TornadoTrees.TreeLeaf[256]',
                name: '_events',
                type: 'tuple[256]',
            },
        ],
        name: 'updateDepositTree',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes', name: '_proof', type: 'bytes' },
            { internalType: 'bytes32', name: '_argsHash', type: 'bytes32' },
            { internalType: 'bytes32', name: '_currentRoot', type: 'bytes32' },
            { internalType: 'bytes32', name: '_newRoot', type: 'bytes32' },
            { internalType: 'uint32', name: '_pathIndices', type: 'uint32' },
            {
                components: [
                    { internalType: 'bytes32', name: 'hash', type: 'bytes32' },
                    { internalType: 'address', name: 'instance', type: 'address' },
                    { internalType: 'uint32', name: 'block', type: 'uint32' },
                ],
                internalType: 'struct TornadoTrees.TreeLeaf[256]',
                name: '_events',
                type: 'tuple[256]',
            },
        ],
        name: 'updateWithdrawalTree',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: '_depositRoot', type: 'bytes32' },
            {
                internalType: 'bytes32',
                name: '_withdrawalRoot',
                type: 'bytes32',
            },
        ],
        name: 'validateRoots',
        outputs: [],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawalRoot',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'withdrawals',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawalsLength',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawalsV1Length',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
];
